<template>
  <v-container>
    <v-card width="800" elevation="0" outlined tile>
      <v-card-title class="headline my-3">現場図の編集</v-card-title>
      <v-card-actions>
        <v-btn elevation="0" tile class="px-5" @click="$router.go(-1)">
          <span class="font-weight-bold">キャンセル</span></v-btn
        >
        <v-btn elevation="0" tile color="error" class="px-5" @click="destroy">
          <span class="font-weight-bold">削除する</span></v-btn
        >
      </v-card-actions>
    </v-card>
  </v-container>
</template>

<script>
import api from "@/api";

export default {
  name: "ConstructionSiteEdit",
  methods: {
    destroy() {
      const { id } = this.$route.params;
      api.construction_sites
        .delete(id)
        .then(() => this.$router.push({ name: "ConstructionSiteIndex" }));
    },
  },
};
</script>
